/**
 * Datos sintéticos deterministas para la propuesta visual M8C (Dashboard de seguimiento).
 * 
 * Basado en la plantilla canónica de 20 atletas de Team Spain Flag 5v5.
 * Todos los datos son completamente sintéticos y aislados de datos reales.
 */

export interface SyntheticAthlete {
  id: string
  dorsal: number
  name: string
  position: 'QB' | 'WR' | 'C' | 'SLOT' | 'RUSH' | 'LB' | 'CB'
  unit: 'Ataque' | 'Defensa'
  club: string
  trackingStatus: 'active' | 'paused' | 'archived'
  availability: 'available_100' | 'limited' | 'needs_assessment' | 'unavailable' | 'not_assessed'
  availabilityNote?: string
  lastAssessmentDate: string
  nextReviewDate?: string
}

export const SYNTHETIC_ATHLETES: SyntheticAthlete[] = [
  {
    id: 'ath-01',
    dorsal: 7,
    name: 'Alejandro García',
    position: 'QB',
    unit: 'Ataque',
    club: 'Madrid Capitals',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-02',
    dorsal: 12,
    name: 'Marcos Ramos',
    position: 'QB',
    unit: 'Ataque',
    club: 'Valencia Firebats',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-03',
    dorsal: 88,
    name: 'Mateo Benítez',
    position: 'WR',
    unit: 'Ataque',
    club: 'Badalona Dracs',
    trackingStatus: 'active',
    availability: 'limited',
    availabilityNote: 'Sobrecarga isquiotibial derecho. Sin contacto ni sprints máximos.',
    lastAssessmentDate: '2026-05-12',
    nextReviewDate: '2026-05-16',
  },
  {
    id: 'ath-04',
    dorsal: 81,
    name: 'Pablo Morales',
    position: 'WR',
    unit: 'Ataque',
    club: 'Madrid Capitals',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-05',
    dorsal: 10,
    name: 'Álvaro Serrano',
    position: 'WR',
    unit: 'Ataque',
    club: 'Las Rozas Black Demons',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-06',
    dorsal: 87,
    name: 'Raúl Romero',
    position: 'WR',
    unit: 'Ataque',
    club: 'Osos Rivas',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-07',
    dorsal: 11,
    name: 'Daniel Gil',
    position: 'SLOT',
    unit: 'Ataque',
    club: 'Valencia Firebats',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-08',
    dorsal: 85,
    name: 'Hugo Castro',
    position: 'SLOT',
    unit: 'Ataque',
    club: 'Badalona Dracs',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-09',
    dorsal: 44,
    name: 'Javier Vidal',
    position: 'C',
    unit: 'Ataque',
    club: 'Madrid Capitals',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-10',
    dorsal: 50,
    name: 'Santiago Ruiz',
    position: 'C',
    unit: 'Ataque',
    club: 'Camioneros Coslada',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-11',
    dorsal: 99,
    name: 'Adrián Martín',
    position: 'RUSH',
    unit: 'Defensa',
    club: 'Las Rozas Black Demons',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-12',
    dorsal: 90,
    name: 'Gonzalo Silva',
    position: 'RUSH',
    unit: 'Defensa',
    club: 'Valencia Firebats',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-13',
    dorsal: 54,
    name: 'Sergio Torres',
    position: 'LB',
    unit: 'Defensa',
    club: 'Madrid Capitals',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-14',
    dorsal: 52,
    name: 'Bruno Cruz',
    position: 'LB',
    unit: 'Defensa',
    club: 'Badalona Dracs',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-15',
    dorsal: 5,
    name: 'David Romero',
    position: 'LB',
    unit: 'Defensa',
    club: 'Osos Rivas',
    trackingStatus: 'active',
    availability: 'limited',
    availabilityNote: 'Molestia tendón rotuliano derecho. Carga controlada en saltos.',
    lastAssessmentDate: '2026-05-11',
    nextReviewDate: '2026-05-15',
  },
  {
    id: 'ath-16',
    dorsal: 48,
    name: 'Rubén Cano',
    position: 'LB',
    unit: 'Defensa',
    club: 'Camioneros Coslada',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-17',
    dorsal: 17,
    name: 'Carlos Vega',
    position: 'CB',
    unit: 'Defensa',
    club: 'Las Rozas Black Demons',
    trackingStatus: 'active',
    availability: 'needs_assessment',
    availabilityNote: 'Molestia lumbar tras partido de club. Pendiente de valoración con fisioterapia.',
    lastAssessmentDate: '2026-05-13',
    nextReviewDate: '2026-05-14',
  },
  {
    id: 'ath-18',
    dorsal: 21,
    name: 'Iker Navarro',
    position: 'CB',
    unit: 'Defensa',
    club: 'Madrid Capitals',
    trackingStatus: 'active',
    availability: 'available_100',
    lastAssessmentDate: '2026-05-10',
  },
  {
    id: 'ath-19',
    dorsal: 33,
    name: 'Diego Santos',
    position: 'CB',
    unit: 'Defensa',
    club: 'Valencia Giants',
    trackingStatus: 'active',
    availability: 'unavailable',
    availabilityNote: 'Esguince ligamento lateral externo tobillo derecho (grado II). En rehabilitación.',
    lastAssessmentDate: '2026-05-05',
    nextReviewDate: '2026-05-20',
  },
  {
    id: 'ath-20',
    dorsal: 24,
    name: 'Lucas Navas',
    position: 'CB',
    unit: 'Defensa',
    club: 'Hospitalet Pioners',
    trackingStatus: 'active',
    availability: 'not_assessed',
    availabilityNote: 'Convocado recientemente; sin valoración médica oficial registrada en la temporada.',
    lastAssessmentDate: '—',
  },
]

export const SYNTHETIC_AVAILABILITY_SUMMARY = {
  available_100: 16,
  limited: 2,
  needs_assessment: 1,
  unavailable: 1,
  not_assessed: 0,
}

// Resumen compacto de cumplimiento de formularios
export const SYNTHETIC_FORM_COMPLIANCE_SUMMARY = {
  submittedCount: 18,
  totalExpected: 20,
  submittedPct: 90,
  draftsCount: 1,
  overdueCount: 1,
  currentWeekLabel: 'Semana 8 (Activa)',
  deadlineNote: 'Lunes 12:00',
}

export const WEEKS_METADATA = [
  { weekNumber: 1, label: 'S1', startDate: '23/03', fullDate: '23-29 Mar' },
  { weekNumber: 2, label: 'S2', startDate: '30/03', fullDate: '30 Mar - 05 Abr' },
  { weekNumber: 3, label: 'S3', startDate: '06/04', fullDate: '06-12 Abr' },
  { weekNumber: 4, label: 'S4', startDate: '13/04', fullDate: '13-19 Abr' },
  { weekNumber: 5, label: 'S5', startDate: '20/04', fullDate: '20-26 Abr' },
  { weekNumber: 6, label: 'S6', startDate: '27/04', fullDate: '27 Abr - 03 May' },
  { weekNumber: 7, label: 'S7', startDate: '04/05', fullDate: '04-10 May' },
  { weekNumber: 8, label: 'S8 (Activa)', startDate: '11/05', fullDate: '11-17 May' },
]

export interface WeeklyWorkloadTeam {
  week: string
  weekNumber: number
  startDate: string
  flagMinutes: number
  strengthMinutes: number
  clubMinutes: number
  matchMinutes: number
  totalMinutes: number
  totalSRPE: number // Arbitrary Units (UA)
  avgSRPE: number
  sampleSize: number // n atletas con registros válidos
}

export const SYNTHETIC_TEAM_WORKLOAD: WeeklyWorkloadTeam[] = [
  {
    week: 'Sem 1',
    weekNumber: 1,
    startDate: '23 Mar',
    flagMinutes: 180,
    strengthMinutes: 120,
    clubMinutes: 140,
    matchMinutes: 0,
    totalMinutes: 440,
    totalSRPE: 2640,
    avgSRPE: 6.0,
    sampleSize: 19,
  },
  {
    week: 'Sem 2',
    weekNumber: 2,
    startDate: '30 Mar',
    flagMinutes: 200,
    strengthMinutes: 130,
    clubMinutes: 160,
    matchMinutes: 50,
    totalMinutes: 540,
    totalSRPE: 3348,
    avgSRPE: 6.2,
    sampleSize: 19,
  },
  {
    week: 'Sem 3',
    weekNumber: 3,
    startDate: '06 Abr',
    flagMinutes: 220,
    strengthMinutes: 140,
    clubMinutes: 150,
    matchMinutes: 60,
    totalMinutes: 570,
    totalSRPE: 3705,
    avgSRPE: 6.5,
    sampleSize: 19,
  },
  {
    week: 'Sem 4',
    weekNumber: 4,
    startDate: '13 Abr',
    flagMinutes: 240,
    strengthMinutes: 150,
    clubMinutes: 180,
    matchMinutes: 60,
    totalMinutes: 630,
    totalSRPE: 4284,
    avgSRPE: 6.8,
    sampleSize: 19,
  },
  {
    week: 'Sem 5',
    weekNumber: 5,
    startDate: '20 Abr',
    flagMinutes: 180,
    strengthMinutes: 110,
    clubMinutes: 130,
    matchMinutes: 0,
    totalMinutes: 420,
    totalSRPE: 2436,
    avgSRPE: 5.8,
    sampleSize: 20,
  },
  {
    week: 'Sem 6',
    weekNumber: 6,
    startDate: '27 Abr',
    flagMinutes: 230,
    strengthMinutes: 140,
    clubMinutes: 190,
    matchMinutes: 70,
    totalMinutes: 630,
    totalSRPE: 4221,
    avgSRPE: 6.7,
    sampleSize: 20,
  },
  {
    week: 'Sem 7',
    weekNumber: 7,
    startDate: '04 May',
    flagMinutes: 260,
    strengthMinutes: 160,
    clubMinutes: 180,
    matchMinutes: 80,
    totalMinutes: 680,
    totalSRPE: 4896,
    avgSRPE: 7.2,
    sampleSize: 20,
  },
  {
    week: 'Sem 8 (Activa)',
    weekNumber: 8,
    startDate: '11 May',
    flagMinutes: 210,
    strengthMinutes: 130,
    clubMinutes: 150,
    matchMinutes: 40,
    totalMinutes: 530,
    totalSRPE: 3445,
    avgSRPE: 6.5,
    sampleSize: 18,
  },
]

export interface WeeklyWellnessSleepTeam {
  week: string
  weekNumber: number
  sampleSize: number
  avgSleepHours: number   // 0..10 h
  avgSleepQuality: number // Escala 1..5
  avgFatigue: number      // Escala 1..5
  avgRecovery: number     // Escala 1..5
  avgStress: number       // Escala 1..5
  avgMuscleSoreness: number // Escala 1..5
  avgMood: number         // Escala 1..5
}

export const SYNTHETIC_WELLNESS_SLEEP_TEAM: WeeklyWellnessSleepTeam[] = [
  { week: 'Sem 1', weekNumber: 1, sampleSize: 19, avgSleepHours: 7.6, avgSleepQuality: 4.1, avgFatigue: 2.3, avgRecovery: 4.0, avgStress: 2.1, avgMuscleSoreness: 2.4, avgMood: 4.2 },
  { week: 'Sem 2', weekNumber: 2, sampleSize: 19, avgSleepHours: 7.4, avgSleepQuality: 3.9, avgFatigue: 2.7, avgRecovery: 3.8, avgStress: 2.4, avgMuscleSoreness: 2.8, avgMood: 4.0 },
  { week: 'Sem 3', weekNumber: 3, sampleSize: 19, avgSleepHours: 7.5, avgSleepQuality: 4.0, avgFatigue: 2.9, avgRecovery: 3.6, avgStress: 2.6, avgMuscleSoreness: 3.1, avgMood: 3.9 },
  { week: 'Sem 4', weekNumber: 4, sampleSize: 19, avgSleepHours: 7.1, avgSleepQuality: 3.6, avgFatigue: 3.4, avgRecovery: 3.2, avgStress: 3.1, avgMuscleSoreness: 3.6, avgMood: 3.6 },
  { week: 'Sem 5', weekNumber: 5, sampleSize: 20, avgSleepHours: 7.9, avgSleepQuality: 4.3, avgFatigue: 2.1, avgRecovery: 4.3, avgStress: 1.9, avgMuscleSoreness: 2.0, avgMood: 4.5 },
  { week: 'Sem 6', weekNumber: 6, sampleSize: 20, avgSleepHours: 7.3, avgSleepQuality: 3.8, avgFatigue: 3.0, avgRecovery: 3.7, avgStress: 2.5, avgMuscleSoreness: 3.0, avgMood: 4.1 },
  { week: 'Sem 7', weekNumber: 7, sampleSize: 20, avgSleepHours: 7.2, avgSleepQuality: 3.7, avgFatigue: 3.5, avgRecovery: 3.3, avgStress: 2.9, avgMuscleSoreness: 3.5, avgMood: 3.8 },
  { week: 'Sem 8', weekNumber: 8, sampleSize: 18, avgSleepHours: 7.4, avgSleepQuality: 3.8, avgFatigue: 2.8, avgRecovery: 3.7, avgStress: 2.3, avgMuscleSoreness: 2.9, avgMood: 4.1 },
]

export interface BodyZoneDiscomfort {
  id: string
  label: string
  view: 'front' | 'back' | 'both'
  episodesCount: number
  affectedAthletesCount: number
  details: {
    athleteId: string
    athleteName: string
    athleteDorsal: number
    laterality: 'derecha' | 'izquierda' | 'bilateral' | 'central'
    type: 'molestia_autodeclarada' | 'valoracion_fisioterapia' | 'baja_medica'
    description: string
    reportedDate: string
  }[]
}

export const SYNTHETIC_BODY_DISCOMFORTS: BodyZoneDiscomfort[] = [
  {
    id: 'isquiotibiales',
    label: 'Isquiotibiales',
    view: 'back',
    episodesCount: 2,
    affectedAthletesCount: 2,
    details: [
      {
        athleteId: 'ath-03',
        athleteName: 'Mateo Benítez',
        athleteDorsal: 88,
        laterality: 'derecha',
        type: 'valoracion_fisioterapia',
        description: 'Sobrecarga muscular tras serie de aceleraciones en club',
        reportedDate: '2026-05-12',
      },
      {
        athleteId: 'ath-20',
        athleteName: 'Lucas Navas',
        athleteDorsal: 24,
        laterality: 'izquierda',
        type: 'molestia_autodeclarada',
        description: 'Tensión isquiosural leve post-partido sin limitación funcional',
        reportedDate: '2026-05-11',
      },
    ],
  },
  {
    id: 'lumbar',
    label: 'Zona Lumbar',
    view: 'back',
    episodesCount: 1,
    affectedAthletesCount: 1,
    details: [
      {
        athleteId: 'ath-17',
        athleteName: 'Carlos Vega',
        athleteDorsal: 17,
        laterality: 'central',
        type: 'valoracion_fisioterapia',
        description: 'Rigidez y dolor lumbar al flexionar tronco',
        reportedDate: '2026-05-13',
      },
    ],
  },
  {
    id: 'rodilla',
    label: 'Rodilla',
    view: 'front',
    episodesCount: 1,
    affectedAthletesCount: 1,
    details: [
      {
        athleteId: 'ath-15',
        athleteName: 'David Romero',
        athleteDorsal: 5,
        laterality: 'derecha',
        type: 'valoracion_fisioterapia',
        description: 'Molestia en polo inferior de rótula tras aterrizajes repetidos',
        reportedDate: '2026-05-11',
      },
    ],
  },
  {
    id: 'tobillo',
    label: 'Tobillo / Pie',
    view: 'both',
    episodesCount: 1,
    affectedAthletesCount: 1,
    details: [
      {
        athleteId: 'ath-19',
        athleteName: 'Diego Santos',
        athleteDorsal: 33,
        laterality: 'derecha',
        type: 'baja_medica',
        description: 'Esguince LLE grado II en rehabilitación guiada',
        reportedDate: '2026-05-05',
      },
    ],
  },
  {
    id: 'hombro',
    label: 'Hombro',
    view: 'both',
    episodesCount: 0,
    affectedAthletesCount: 0,
    details: [],
  },
  {
    id: 'cuadriceps',
    label: 'Cuádriceps',
    view: 'front',
    episodesCount: 0,
    affectedAthletesCount: 0,
    details: [],
  },
  {
    id: 'gemelo_aquiles',
    label: 'Gemelo / Aquiles',
    view: 'back',
    episodesCount: 0,
    affectedAthletesCount: 0,
    details: [],
  },
]

export const SYNTHETIC_DISCOMFORT_METRICS = {
  totalEpisodes: 5,
  totalAffectedPlayers: 4,
  mostReportedZone: 'Isquiotibiales (2 episodios)',
  activeMedicalLeaveCount: 1,
  activePhysioCareCount: 3,
  selfReportedOnlyCount: 1,
}

export interface PendingAction {
  id: string
  type: 'form' | 'contact_request' | 'availability_review'
  title: string
  subtitle: string
  severity: 'high' | 'medium' | 'low'
  date: string
  athleteId: string
  athleteName: string
  athleteDorsal: number
}

export const SYNTHETIC_PENDING_ACTIONS: PendingAction[] = [
  {
    id: 'act-1',
    type: 'contact_request',
    title: 'Solicitud de valoración médica',
    subtitle: 'Sobrecarga y dolor en isquiotibial derecho tras sprint (Dolor 6/10)',
    severity: 'high',
    date: '12 May 2026',
    athleteId: 'ath-03',
    athleteName: 'Mateo Benítez',
    athleteDorsal: 88,
  },
  {
    id: 'act-2',
    type: 'availability_review',
    title: 'Revisión de disponibilidad programada',
    subtitle: 'Revalorar molestia lumbar antes de la concentración del 15 de Mayo',
    severity: 'medium',
    date: '14 May 2026',
    athleteId: 'ath-17',
    athleteName: 'Carlos Vega',
    athleteDorsal: 17,
  },
  {
    id: 'act-3',
    type: 'form',
    title: 'Formulario semanal vencido',
    subtitle: 'Semana 8 pendiente de entrega (plazo superado por 24h)',
    severity: 'medium',
    date: '12 May 2026',
    athleteId: 'ath-19',
    athleteName: 'Diego Santos',
    athleteDorsal: 33,
  },
  {
    id: 'act-4',
    type: 'form',
    title: 'Formulario semanal en borrador',
    subtitle: 'Semana 8 con respuestas parciales guardadas online',
    severity: 'low',
    date: '13 May 2026',
    athleteId: 'ath-20',
    athleteName: 'Lucas Navas',
    athleteDorsal: 24,
  },
]

// ==========================================
// RENDIMIENTO DEPORTIVO DEL EQUIPO (VISTA B)
// ==========================================

export interface TeamSportPerformanceData {
  offense: {
    validSnaps: number
    netYards: number
    yardsPerSnap: number
    passAttempts: number
    passCompletions: number
    completionPct: number
    passYards: number
    passTouchdowns: number
    interceptionsLost: number
    rushAttempts: number
    rushYards: number
    rushTouchdowns: number
    totalTouchdowns: number
    explosivePlays10Plus: number
    explosivePlaysPct: number
    turnoversLost: number
  }
  defense: {
    validSnaps: number
    yardsAllowed: number
    yardsAllowedPerSnap: number
    flagAttempts: number
    flagsMade: number
    flagTacklePct: number
    turnoversForced: number
    interceptionsMade: number
    turnoverOnDowns: number
    blitzSnaps: number
    blitzPressures: number
    blitzSacks: number
    blitzDisruptionPct: number
    touchdownsAllowed: number
  }
  games: {
    id: string
    date: string
    label: string
    type: 'partido_oficial' | 'scrimmage_guiado'
    opponent: string
    ourScore: number
    oppScore: number
    snaps: number
    netYards: number
    yardsPerSnap: number
    completionPct: number
    explosivePlays: number
    turnoversDiff: number
  }[]
  conceptsOffense: {
    concept: string
    snaps: number
    netYards: number
    yardsPerSnap: number
    completionPct: number
    touchdowns: number
    successRate: number // % jugadas con ganancia >= 4 yd
  }[]
  callsDefense: {
    coverageCall: string
    snaps: number
    yardsAllowed: number
    yardsPerSnapAllowed: number
    interceptions: number
    sacks: number
    stopRate: number // % jugadas con ganancia < 4 yd o turnover
  }[]
  yardDistribution: {
    range: string
    label: string
    count: number
    percentage: number
  }[]
  lineupsOffense: {
    id: string
    players: string
    snaps: number
    netYards: number
    yardsPerSnap: number
    completionPct: number
    touchdowns: number
  }[]
  lineupsDefense: {
    id: string
    players: string
    snaps: number
    yardsAllowed: number
    yardsPerSnapAllowed: number
    interceptions: number
    sacks: number
  }[]
}

export const SYNTHETIC_SPORT_PERFORMANCE: TeamSportPerformanceData = {
  offense: {
    validSnaps: 142,
    netYards: 768,
    yardsPerSnap: 5.4,
    passAttempts: 112,
    passCompletions: 78,
    completionPct: 69.6,
    passYards: 624,
    passTouchdowns: 15,
    interceptionsLost: 4,
    rushAttempts: 30,
    rushYards: 144,
    rushTouchdowns: 7,
    totalTouchdowns: 22,
    explosivePlays10Plus: 28,
    explosivePlaysPct: 19.7,
    turnoversLost: 4,
  },
  defense: {
    validSnaps: 138,
    yardsAllowed: 580,
    yardsAllowedPerSnap: 4.2,
    flagAttempts: 108,
    flagsMade: 92,
    flagTacklePct: 85.2,
    turnoversForced: 9,
    interceptionsMade: 7,
    turnoverOnDowns: 2,
    blitzSnaps: 42,
    blitzPressures: 18,
    blitzSacks: 6,
    blitzDisruptionPct: 57.1,
    touchdownsAllowed: 14,
  },
  games: [
    { id: 'g-01', date: '2026-03-28', label: 'Jornada 1', type: 'scrimmage_guiado', opponent: 'Madrid All-Stars (Práctica)', ourScore: 26, oppScore: 18, snaps: 24, netYards: 122, yardsPerSnap: 5.1, completionPct: 65.0, explosivePlays: 4, turnoversDiff: +1 },
    { id: 'g-02', date: '2026-04-11', label: 'Jornada 2', type: 'partido_oficial', opponent: 'Francia Flag', ourScore: 33, oppScore: 27, snaps: 28, netYards: 156, yardsPerSnap: 5.6, completionPct: 71.4, explosivePlays: 6, turnoversDiff: +2 },
    { id: 'g-03', date: '2026-04-18', label: 'Jornada 3', type: 'partido_oficial', opponent: 'Italia Flag', ourScore: 28, oppScore: 34, snaps: 26, netYards: 138, yardsPerSnap: 5.3, completionPct: 68.0, explosivePlays: 5, turnoversDiff: -1 },
    { id: 'g-04', date: '2026-04-25', label: 'Jornada 4', type: 'scrimmage_guiado', opponent: 'Team Blue vs White', ourScore: 31, oppScore: 20, snaps: 22, netYards: 114, yardsPerSnap: 5.2, completionPct: 70.0, explosivePlays: 4, turnoversDiff: +1 },
    { id: 'g-05', date: '2026-05-02', label: 'Jornada 5', type: 'partido_oficial', opponent: 'Gran Bretaña', ourScore: 40, oppScore: 26, snaps: 25, netYards: 145, yardsPerSnap: 5.8, completionPct: 76.0, explosivePlays: 6, turnoversDiff: +2 },
    { id: 'g-06', date: '2026-05-09', label: 'Jornada 6', type: 'partido_oficial', opponent: 'Alemania Flag', ourScore: 24, oppScore: 21, snaps: 17, netYards: 93, yardsPerSnap: 5.5, completionPct: 64.7, explosivePlays: 3, turnoversDiff: 0 },
  ],
  conceptsOffense: [
    { concept: 'Base', snaps: 38, netYards: 220, yardsPerSnap: 5.8, completionPct: 71.4, touchdowns: 6, successRate: 68.4 },
    { concept: 'Dinámico', snaps: 42, netYards: 248, yardsPerSnap: 5.9, completionPct: 75.0, touchdowns: 8, successRate: 71.4 },
    { concept: 'Hydra (Multi-QB)', snaps: 22, netYards: 106, yardsPerSnap: 4.8, completionPct: 60.0, touchdowns: 3, successRate: 54.5 },
    { concept: 'Standard', snaps: 40, netYards: 194, yardsPerSnap: 4.8, completionPct: 64.5, touchdowns: 5, successRate: 57.5 },
  ],
  callsDefense: [
    { coverageCall: 'Cover 1', snaps: 35, yardsAllowed: 158, yardsPerSnapAllowed: 4.5, interceptions: 3, sacks: 1, stopRate: 65.7 },
    { coverageCall: 'Cover 2', snaps: 44, yardsAllowed: 167, yardsPerSnapAllowed: 3.8, interceptions: 2, sacks: 0, stopRate: 72.7 },
    { coverageCall: 'Cover 3', snaps: 28, yardsAllowed: 118, yardsPerSnapAllowed: 4.2, interceptions: 1, sacks: 0, stopRate: 67.9 },
    { coverageCall: 'Blitz Man', snaps: 31, yardsAllowed: 137, yardsPerSnapAllowed: 4.4, interceptions: 1, sacks: 5, stopRate: 74.2 },
  ],
  yardDistribution: [
    { range: '<0 yd', label: 'Pérdida (<0 yd)', count: 12, percentage: 8.5 },
    { range: '0-3 yd', label: '0 — 3 yardas', count: 34, percentage: 23.9 },
    { range: '4-9 yd', label: '4 — 9 yardas', count: 52, percentage: 36.6 },
    { range: '10-19 yd', label: '10 — 19 yardas', count: 28, percentage: 19.7 },
    { range: '20+ yd', label: '20+ yardas (Explosivas)', count: 16, percentage: 11.3 },
  ],
  lineupsOffense: [
    { id: 'l-off-1', players: '#7 A. García, #88 M. Benítez, #81 P. Morales, #11 D. Gil, #44 J. Vidal', snaps: 54, netYards: 318, yardsPerSnap: 5.9, completionPct: 74.1, touchdowns: 11 },
    { id: 'l-off-2', players: '#7 A. García, #88 M. Benítez, #10 Á. Serrano, #85 H. Castro, #44 J. Vidal', snaps: 36, netYards: 187, yardsPerSnap: 5.2, completionPct: 68.0, touchdowns: 6 },
    { id: 'l-off-3', players: '#12 M. Ramos, #88 M. Benítez, #81 P. Morales, #87 R. Romero, #50 S. Ruiz', snaps: 28, netYards: 129, yardsPerSnap: 4.6, completionPct: 62.5, touchdowns: 3 },
    { id: 'l-off-4', players: '#7 A. García, #10 Á. Serrano, #87 R. Romero, #11 D. Gil, #50 S. Ruiz', snaps: 24, netYards: 134, yardsPerSnap: 5.6, completionPct: 70.0, touchdowns: 2 },
  ],
  lineupsDefense: [
    { id: 'l-def-1', players: '#99 A. Martín, #54 S. Torres, #52 B. Cruz, #17 C. Vega, #21 I. Navarro', snaps: 48, yardsAllowed: 187, yardsPerSnapAllowed: 3.9, interceptions: 4, sacks: 3 },
    { id: 'l-def-2', players: '#90 G. Silva, #54 S. Torres, #48 R. Cano, #18 I. Navarro, #33 D. Santos', snaps: 38, yardsAllowed: 167, yardsPerSnapAllowed: 4.4, interceptions: 2, sacks: 1 },
    { id: 'l-def-3', players: '#99 A. Martín, #52 B. Cruz, #5 D. Romero, #17 C. Vega, #24 L. Navas', snaps: 28, yardsAllowed: 120, yardsPerSnapAllowed: 4.3, interceptions: 1, sacks: 2 },
    { id: 'l-def-4', players: '#90 G. Silva, #54 S. Torres, #5 D. Romero, #21 I. Navarro, #24 L. Navas', snaps: 24, yardsAllowed: 106, yardsPerSnapAllowed: 4.4, interceptions: 0, sacks: 0 },
  ],
}

// ==========================================
// RENDIMIENTO INDIVIDUAL DEL JUGADOR (VISTA C)
// ==========================================

export interface IndividualPlayerPerformance {
  athleteId: string
  athleteName: string
  dorsal: number
  primaryPosition: string
  unit: 'Ataque' | 'Defensa'
  club: string
  totalSnapsPlayed: number
  passing?: {
    attempts: number
    completions: number
    completionPct: number
    yards: number
    touchdowns: number
    interceptions: number
    yardsPerAttempt: number
    explosivePasses: number
    sacksSuffered: number
  }
  receiving?: {
    targetsKnown: number
    receptions: number
    catchPct: number
    drops: number
    yards: number
    yardsPerTarget: number
    touchdowns: number
    longGain: number
  }
  defense?: {
    flagAttempts: number
    flagsMade: number
    flagsMissed: number
    flagTacklePct: number
    passesDefended: number
    interceptions: number
    pressures: number
    sacks: number
  }
  periodComparison: {
    periodA: { label: string; snaps: number; metric1: string; val1: number; metric2: string; val2: number }
    periodB: { label: string; snaps: number; metric1: string; val1: number; metric2: string; val2: number }
  }
  connections: {
    targetAthleteId: string
    targetName: string
    targetDorsal: number
    attempts: number
    completions: number
    completionPct: number
    yards: number
    touchdowns: number
    interceptions: number
    sampleNote: string
  }[]
  withWithoutTeammates: {
    teammateId: string
    teammateName: string
    teammateDorsal: number
    snapsTogether: number
    yardsPerSnapTogether: number
    successRateTogether: number
    snapsWithout: number
    yardsPerSnapWithout: number
    successRateWithout: number
    deltaYards: number
  }[]
}

export function getIndividualPlayerPerformance(athleteId: string): IndividualPlayerPerformance {
  const athlete = SYNTHETIC_ATHLETES.find((a) => a.id === athleteId) || SYNTHETIC_ATHLETES[0]

  // Alejandro García (#7 - QB titular)
  if (athlete.id === 'ath-01') {
    return {
      athleteId: athlete.id,
      athleteName: athlete.name,
      dorsal: athlete.dorsal,
      primaryPosition: athlete.position,
      unit: athlete.unit,
      club: athlete.club,
      totalSnapsPlayed: 114,
      passing: {
        attempts: 92,
        completions: 66,
        completionPct: 71.7,
        yards: 532,
        touchdowns: 13,
        interceptions: 3,
        yardsPerAttempt: 5.78,
        explosivePasses: 22,
        sacksSuffered: 4,
      },
      periodComparison: {
        periodA: { label: 'Conc. Marzo 2026', snaps: 48, metric1: '% Completos', val1: 67.5, metric2: 'Yd / Intento', val2: 5.2 },
        periodB: { label: 'Conc. Mayo 2026', snaps: 66, metric1: '% Completos', val1: 74.2, metric2: 'Yd / Intento', val2: 6.1 },
      },
      connections: [
        { targetAthleteId: 'ath-03', targetName: 'Mateo Benítez', targetDorsal: 88, attempts: 38, completions: 28, completionPct: 73.7, yards: 244, touchdowns: 7, interceptions: 1, sampleNote: 'n=38 pases' },
        { targetAthleteId: 'ath-04', targetName: 'Pablo Morales', targetDorsal: 81, attempts: 24, completions: 16, completionPct: 66.7, yards: 138, touchdowns: 3, interceptions: 1, sampleNote: 'n=24 pases' },
        { targetAthleteId: 'ath-05', targetName: 'Álvaro Serrano', targetDorsal: 10, attempts: 18, completions: 12, completionPct: 66.7, yards: 92, touchdowns: 2, interceptions: 0, sampleNote: 'n=18 pases' },
        { targetAthleteId: 'ath-07', targetName: 'Daniel Gil', targetDorsal: 11, attempts: 14, completions: 10, completionPct: 71.4, yards: 78, touchdowns: 2, interceptions: 1, sampleNote: 'n=14 pases' },
        { targetAthleteId: 'ath-09', targetName: 'Javier Vidal', targetDorsal: 44, attempts: 8, completions: 6, completionPct: 75.0, yards: 36, touchdowns: 0, interceptions: 0, sampleNote: 'n=8 pases (Centro)' },
        { targetAthleteId: 'ath-06', targetName: 'Raúl Romero', targetDorsal: 87, attempts: 4, completions: 3, completionPct: 75.0, yards: 24, touchdowns: 1, interceptions: 0, sampleNote: 'n=4 pases (Muestra reducida)' },
      ],
      withWithoutTeammates: [
        { teammateId: 'ath-03', teammateName: 'Mateo Benítez', teammateDorsal: 88, snapsTogether: 64, yardsPerSnapTogether: 6.1, successRateTogether: 75.0, snapsWithout: 50, yardsPerSnapWithout: 4.6, successRateWithout: 60.0, deltaYards: +1.5 },
        { teammateId: 'ath-04', teammateName: 'Pablo Morales', teammateDorsal: 81, snapsTogether: 52, yardsPerSnapTogether: 5.7, successRateTogether: 71.2, snapsWithout: 62, yardsPerSnapWithout: 5.1, successRateWithout: 64.5, deltaYards: +0.6 },
        { teammateId: 'ath-09', teammateName: 'Javier Vidal', teammateDorsal: 44, snapsTogether: 82, yardsPerSnapTogether: 5.8, successRateTogether: 72.0, snapsWithout: 32, yardsPerSnapWithout: 4.5, successRateWithout: 59.4, deltaYards: +1.3 },
      ],
    }
  }

  // Mateo Benítez (#88 - WR principal, ¡con pases en formación Hydra!)
  if (athlete.id === 'ath-03') {
    return {
      athleteId: athlete.id,
      athleteName: athlete.name,
      dorsal: athlete.dorsal,
      primaryPosition: athlete.position,
      unit: athlete.unit,
      club: athlete.club,
      totalSnapsPlayed: 98,
      // Recepción como rol principal
      receiving: {
        targetsKnown: 52,
        receptions: 37,
        catchPct: 71.2,
        drops: 2,
        yards: 326,
        yardsPerTarget: 6.27,
        touchdowns: 8,
        longGain: 34,
      },
      // ¡Pase real registrado en jugadas tácticas Hydra! Cumple requerimiento 5
      passing: {
        attempts: 2,
        completions: 1,
        completionPct: 50.0,
        yards: 18,
        touchdowns: 1,
        interceptions: 0,
        yardsPerAttempt: 9.0,
        explosivePasses: 1,
        sacksSuffered: 0,
      },
      periodComparison: {
        periodA: { label: 'Conc. Marzo 2026', snaps: 42, metric1: 'Yardas / Target', val1: 5.8, metric2: '% Captura', val2: 68.2 },
        periodB: { label: 'Conc. Mayo 2026', snaps: 56, metric1: 'Yardas / Target', val1: 6.6, metric2: '% Captura', val2: 73.3 },
      },
      connections: [
        { targetAthleteId: 'ath-01', targetName: 'Alejandro García (Lanzador)', targetDorsal: 7, attempts: 38, completions: 28, completionPct: 73.7, yards: 244, touchdowns: 7, interceptions: 1, sampleNote: 'n=38 pases recibidos' },
        { targetAthleteId: 'ath-02', targetName: 'Marcos Ramos (Lanzador)', targetDorsal: 12, attempts: 14, completions: 9, completionPct: 64.3, yards: 82, touchdowns: 1, interceptions: 0, sampleNote: 'n=14 pases recibidos' },
      ],
      withWithoutTeammates: [
        { teammateId: 'ath-01', teammateName: 'Alejandro García', teammateDorsal: 7, snapsTogether: 64, yardsPerSnapTogether: 6.1, successRateTogether: 75.0, snapsWithout: 34, yardsPerSnapWithout: 4.8, successRateWithout: 61.8, deltaYards: +1.3 },
        { teammateId: 'ath-07', teammateName: 'Daniel Gil', teammateDorsal: 11, snapsTogether: 46, yardsPerSnapTogether: 5.9, successRateTogether: 73.9, snapsWithout: 52, yardsPerSnapWithout: 5.1, successRateWithout: 63.5, deltaYards: +0.8 },
      ],
    }
  }

  // Adrián Martín (#99 - RUSH / Blitz)
  if (athlete.id === 'ath-11') {
    return {
      athleteId: athlete.id,
      athleteName: athlete.name,
      dorsal: athlete.dorsal,
      primaryPosition: athlete.position,
      unit: athlete.unit,
      club: athlete.club,
      totalSnapsPlayed: 92,
      defense: {
        flagAttempts: 44,
        flagsMade: 38,
        flagsMissed: 6,
        flagTacklePct: 86.4,
        passesDefended: 3,
        interceptions: 1,
        pressures: 14,
        sacks: 5,
      },
      periodComparison: {
        periodA: { label: 'Conc. Marzo 2026', snaps: 38, metric1: '% Flags', val1: 82.5, metric2: 'Sacks', val2: 2 },
        periodB: { label: 'Conc. Mayo 2026', snaps: 54, metric1: '% Flags', val1: 88.9, metric2: 'Sacks', val2: 3 },
      },
      connections: [],
      withWithoutTeammates: [
        { teammateId: 'ath-13', teammateName: 'Sergio Torres (LB)', teammateDorsal: 54, snapsTogether: 58, yardsPerSnapTogether: 3.8, successRateTogether: 74.1, snapsWithout: 34, yardsPerSnapWithout: 4.6, successRateWithout: 61.8, deltaYards: -0.8 },
        { teammateId: 'ath-14', teammateName: 'Bruno Cruz (LB)', teammateDorsal: 52, snapsTogether: 48, yardsPerSnapTogether: 4.0, successRateTogether: 70.8, snapsWithout: 44, yardsPerSnapWithout: 4.5, successRateWithout: 63.6, deltaYards: -0.5 },
      ],
    }
  }

  // Generador determinista para el resto de atletas
  const isOffense = athlete.unit === 'Ataque'
  return {
    athleteId: athlete.id,
    athleteName: athlete.name,
    dorsal: athlete.dorsal,
    primaryPosition: athlete.position,
    unit: athlete.unit,
    club: athlete.club,
    totalSnapsPlayed: 65 + (athlete.dorsal % 30),
    receiving: isOffense ? {
      targetsKnown: 24 + (athlete.dorsal % 15),
      receptions: 16 + (athlete.dorsal % 10),
      catchPct: 68.0,
      drops: 1,
      yards: 120 + athlete.dorsal * 2,
      yardsPerTarget: 5.4,
      touchdowns: 2 + (athlete.dorsal % 3),
      longGain: 22,
    } : undefined,
    defense: !isOffense ? {
      flagAttempts: 32 + (athlete.dorsal % 12),
      flagsMade: 27 + (athlete.dorsal % 10),
      flagsMissed: 4,
      flagTacklePct: 84.4,
      passesDefended: 2 + (athlete.dorsal % 4),
      interceptions: athlete.dorsal % 3,
      pressures: athlete.position === 'RUSH' ? 12 : 2,
      sacks: athlete.position === 'RUSH' ? 3 : 0,
    } : undefined,
    periodComparison: {
      periodA: { label: 'Conc. Marzo 2026', snaps: 30, metric1: 'Efectividad', val1: 65.0, metric2: 'Rendimiento', val2: 5.1 },
      periodB: { label: 'Conc. Mayo 2026', snaps: 42, metric1: 'Efectividad', val1: 72.0, metric2: 'Rendimiento', val2: 5.7 },
    },
    connections: isOffense ? [
      { targetAthleteId: 'ath-01', targetName: 'Alejandro García', targetDorsal: 7, attempts: 18, completions: 12, completionPct: 66.7, yards: 96, touchdowns: 2, interceptions: 0, sampleNote: 'n=18 pases' }
    ] : [],
    withWithoutTeammates: [
      { teammateId: 'ath-13', teammateName: 'Sergio Torres', teammateDorsal: 54, snapsTogether: 36, yardsPerSnapTogether: 4.2, successRateTogether: 68.0, snapsWithout: 30, yardsPerSnapWithout: 4.8, successRateWithout: 60.0, deltaYards: -0.6 }
    ],
  }
}

// Evaluación de viabilidad de métricas propuestas (Requerimiento 7)
export interface ProposedMetricEvaluation {
  id: string
  name: string
  formula: string
  requiredData: string
  status: 'disponible' | 'parcialmente_disponible' | 'no_disponible'
  notes: string
}

export const PROPOSED_METRICS_EVALUATION: ProposedMetricEvaluation[] = [
  {
    id: 'big_plays_10_plus',
    name: 'Jugadas de al menos 10 yardas',
    formula: 'yard_line_end - yard_line_start >= 10',
    requiredData: 'yard_line_start, yard_line_end en snaps válidos',
    status: 'disponible',
    notes: 'Totalmente viable con el SPORT_CONTRACT v1.2 existente. Se calcula automáticamente en campo.',
  },
  {
    id: 'int_per_pass_attempt',
    name: 'INT por intento de pase',
    formula: 'COUNT(interceptions) / COUNT(pass_attempts) * 100',
    requiredData: 'event_type = pass_complete | pass_incomplete | interception',
    status: 'disponible',
    notes: 'Disponible. Tasa cuantitativa de riesgo del lanzador sin interpretaciones subjetivas.',
  },
  {
    id: 'yards_per_known_target',
    name: 'Yardas por target conocido',
    formula: 'SUM(net_yards en recepciones) / COUNT(targets anotados)',
    requiredData: 'target_player_id en eventos de pase',
    status: 'disponible',
    notes: 'Disponible cuando el anotador registra el receptor previsto en pases incompletos.',
  },
  {
    id: 'flag_tackles_pct',
    name: 'Flags conseguidos sobre intentos',
    formula: 'flags_made / (flags_made + flags_missed) * 100',
    requiredData: 'event_type = flag_pull y event_type = missed_flag',
    status: 'disponible',
    notes: 'Disponible cuando los analistas de campo registran el intento de flag fallado.',
  },
  {
    id: 'blitz_disruption_rate',
    name: 'Presiones/sacks por snap de blitz',
    formula: '(pressures + sacks) / blitz_snaps * 100',
    requiredData: 'snaps con defensive_call = Blitz Man o rusher activo',
    status: 'disponible',
    notes: 'Disponible. Evalúa el impacto de la presión defensiva sobre jugadas con rusher asignado.',
  },
  {
    id: 'conversions_pct',
    name: 'Conversiones por intentos identificados',
    formula: 'COUNT(conversiones_exitosas) / COUNT(intentos_conversion) * 100',
    requiredData: 'is_extra_point_try = true, conversion_points = 1 | 2',
    status: 'no_disponible',
    notes: 'No disponible con el registro actual. En v0 la consola registra el TD pero el intento de punto extra se captura como snap normal sin flag de conversión explícita.',
  },
]

export interface PhysicalTestRecord {
  testId: string
  testName: string
  direction: 'lower_is_better' | 'higher_is_better'
  delta: number
  deltaPercent: number
  unit: string
  sessionA: { value: number }
  sessionB: { value: number }
  teamMedian: number
}

export function getAthletePhysicalTests(): PhysicalTestRecord[] {
  return [
    {
      testId: '40yd',
      testName: 'Sprint 40 yardas',
      direction: 'lower_is_better',
      delta: -0.08,
      deltaPercent: -1.7,
      unit: 's',
      sessionA: { value: 4.82 },
      sessionB: { value: 4.74 },
      teamMedian: 4.86,
    },
    {
      testId: 'vertical_jump',
      testName: 'Salto vertical (CMJ)',
      direction: 'higher_is_better',
      delta: 3.2,
      deltaPercent: 5.5,
      unit: 'cm',
      sessionA: { value: 58.5 },
      sessionB: { value: 61.7 },
      teamMedian: 56.4,
    },
    {
      testId: 'pro_agility',
      testName: 'Pro Agility 5-10-5',
      direction: 'lower_is_better',
      delta: -0.11,
      deltaPercent: -2.4,
      unit: 's',
      sessionA: { value: 4.45 },
      sessionB: { value: 4.34 },
      teamMedian: 4.52,
    },
  ]
}

export interface WellnessHistoryRecord {
  date: string
  sleepHours: number
  sleepQuality: number
  fatigue: number
  recovery: number
  soreness: number
}

export function getAthleteWellnessHistory(): WellnessHistoryRecord[] {
  return [
    { date: 'Semana 6', sleepHours: 7.8, sleepQuality: 4, fatigue: 2, recovery: 4, soreness: 2 },
    { date: 'Semana 7', sleepHours: 7.5, sleepQuality: 4, fatigue: 3, recovery: 4, soreness: 2 },
    { date: 'Semana 8', sleepHours: 8.1, sleepQuality: 5, fatigue: 2, recovery: 5, soreness: 1 },
  ]
}

export interface WeeklyComplianceRecord {
  athleteId: string
  athleteName: string
  weekNumber: number
  status: 'submitted' | 'late' | 'draft' | 'pending' | 'missed' | 'not_required'
  rpeSubmitted?: boolean
  wellnessSubmitted?: boolean
  submittedAt?: string
}

export function getSyntheticComplianceMatrix(): WeeklyComplianceRecord[] {
  return SYNTHETIC_ATHLETES.flatMap((athlete) =>
    WEEKS_METADATA.map((w) => {
      let status: 'submitted' | 'late' | 'draft' | 'pending' | 'missed' | 'not_required' = 'submitted'
      if (w.weekNumber === 8) {
        if (athlete.id === 'ath-07') status = 'pending'
        else if (athlete.id === 'ath-14') status = 'draft'
      }
      return {
        athleteId: athlete.id,
        athleteName: athlete.name,
        weekNumber: w.weekNumber,
        status,
        submittedAt: status === 'submitted' ? '2026-05-11 10:30' : undefined,
      }
    })
  )
}
